import { current } from '../helpers'
import { kanbansBoardsPath, kanbanColumnsPath } from '../routes'
import SelectAllController from './select_all_controller'
import { Sortable } from './mixins/sortable'

const BOARDS_FRAME_ID = 'kanban_boards'
const COLUMNS_FRAME_ID = 'kanban_columns'

export default class extends Sortable(SelectAllController) {
  static targets = [
    'projectSelect', 'submitButton',
    'projectStep', 'boardStep', 'columnStep',
    'checkboxAll', 'checkbox', 'sortableItem'
  ]

  connect () {
    const boards = document.getElementById(BOARDS_FRAME_ID)
    if (boards) this.initialBoardsHTML = boards.innerHTML
    const columns = document.getElementById(COLUMNS_FRAME_ID)
    if (columns) this.initialColumnsHTML = columns.innerHTML
  }

  selectProject () {
    this.resetSubmitButton()
    this.resetColumns()
    this.setStepState(this.columnStepTarget, 'disabled')
    if (this.projectId) {
      this.loadBoards()
      this.setStepState(this.projectStepTarget, 'done')
      this.setStepState(this.boardStepTarget, 'active')
    } else {
      this.resetBoards()
      this.setStepState(this.projectStepTarget, 'active')
      this.setStepState(this.boardStepTarget, 'disabled')
    }
  }

  selectKanbanBoard ({ target }) {
    this.loadColumns(target.value)
    this.setStepState(this.boardStepTarget, 'done')
    this.setStepState(this.columnStepTarget, 'active')
  }

  selectColumn () {
    this.updateSubmitButtonState()
  }

  onDragEnd () {
    this.updateSubmitButtonState()
  }

  refresh () {
    super.refresh()
    this.updateSubmitButtonState()
  }

  loadBoards () {
    const frame = document.getElementById(BOARDS_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.cardsGridSkeleton())
    frame.src = kanbansBoardsPath(current.account.id, { project_id: this.projectId })
  }

  loadColumns (cardTableId) {
    const frame = document.getElementById(COLUMNS_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.listSkeleton())
    frame.src = kanbanColumnsPath(current.account.id, cardTableId, { project_id: this.projectId })
  }

  resetBoards () {
    const frame = document.getElementById(BOARDS_FRAME_ID)
    if (!frame || this.initialBoardsHTML == null) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialBoardsHTML
  }

  resetColumns () {
    const frame = document.getElementById(COLUMNS_FRAME_ID)
    if (!frame || this.initialColumnsHTML == null) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialColumnsHTML
  }

  updateSubmitButtonState () {
    const hasColumns = this.checked.length >= 1
    this.submitButtonDisabled = !hasColumns
    this.submitButtonVisible = hasColumns
    if (hasColumns) this.setStepState(this.columnStepTarget, 'done')
  }

  get projectId () {
    const hidden = this.element.querySelector('input[type="hidden"][name="kanban[project_id]"]')
    return hidden?.value || this.projectSelectTarget.value
  }
}
